import { useContext } from "react";
import { createPortal } from "react-dom";
import { PhoneFrameContext } from "../layout/PhoneFrame";

export default function BottomDrawer({
  open = false,
  onClose,
  showClose = false,
  closeOnBackdrop = false,
  showLater = false,
  laterLabel = "بعدا",
  children,
}) {
  const frameEl = useContext(PhoneFrameContext);

  const handleBackdropClick = () => {
    if (closeOnBackdrop && onClose) {
      onClose();
    }
  };

  if (!frameEl) return null;

  return createPortal(
    <div
      className={`absolute inset-0 z-[200] flex flex-col justify-end ${
        open ? "visible" : "invisible pointer-events-none"
      }`}
    >
      <div
        className={`absolute inset-0 bg-black/50 transition-opacity duration-300 ${
          open ? "opacity-100" : "opacity-0"
        }`}
        onClick={handleBackdropClick}
      />
      <div
        className={`relative w-full bg-scabWhite rounded-t-[28px] px-5 pt-3 pb-6 transition-transform duration-300 ease-out ${
          open ? "translate-y-0" : "translate-y-full"
        }`}
      >
        <div className="w-[48px] h-[4px] rounded-full bg-scabLightGray mx-auto mb-3" />
        {showClose ? (
          <button
            type="button"
            className="absolute right-4 top-4 w-8 h-8 flex items-center justify-center text-scabBtnGray z-10"
            onClick={onClose}
            aria-label="بستن"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M6 6l12 12M18 6L6 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        ) : null}
        {children}
        {showLater ? (
          <button
            type="button"
            className="w-full mt-3 h-[48px] rounded-[14px] font-IRANSansBold text-medium text-scabBtnGray"
            onClick={onClose}
          >
            {laterLabel}
          </button>
        ) : null}
      </div>
    </div>,
    frameEl
  );
}
